import Timer from "@stardust/timer";
import Slider from "@stardust/slider";
import { registerThemeEditorSection } from "@stardust/theme-editor";

class StoreMessagesSection {
  constructor(element) {
    this.element = element;
    this.slider = null;
    this.timers = [];
  }

  load() {
    // Initialize slider if multiple messages
    const sliderEl = this.element.querySelector('[data-slider]');
    if (sliderEl) {
      this.slider = new Slider(sliderEl, {
        snap: true,
        autoplay: true,
        interval: 4000
      });
    }

    // Initialize all timers
    this.element.querySelectorAll("[data-timer]").forEach(timerElement => {
      this.timers.push(new Timer(timerElement));
    });
  }

  unload() {
    this.slider = null;
    this.timers.forEach(timer => timer.stop());
    this.timers = [];
  }
}

// Auto-initialize sections on DOM ready
if (typeof document !== 'undefined') {
  const initStoreMessages = () => {
    document.querySelectorAll('[data-section-type="store-messages"]').forEach(section => {
      new StoreMessagesSection(section).load();
    });
  };

  initStoreMessages();
}

registerThemeEditorSection('store-messages', StoreMessagesSection);